import {
  QuestionReviewTaskDetailsPageHeader,
  QuestionReviewTaskDetailsProvider,
  QuestionReviewTaskDetailsRouteController,
} from '@exam-management/new-question-review-task-details';
import { useParams } from '@exam-management/router';
import { TaskManagementPermissionRoute } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function MyTaskQuestionReviewTaskDetailsLayout() {
  const { taskId } = useParams('/my-task/question-review/:taskId');

  return (
    <TaskManagementPermissionRoute taskId={taskId}>
      <QuestionReviewTaskDetailsProvider taskId={taskId}>
        <QuestionReviewTaskDetailsRouteController>
          <QuestionReviewTaskDetailsPageHeader />
          <Outlet />
        </QuestionReviewTaskDetailsRouteController>
      </QuestionReviewTaskDetailsProvider>
    </TaskManagementPermissionRoute>
  );
}
